import React, { useState } from 'react';
import { FaTimes,  FaPhone } from 'react-icons/fa';
import { CgMenuRight } from 'react-icons/cg';
import { IconContext } from 'react-icons';
import { GiHouse} from 'react-icons/gi';
import {
	Nav,
	NavbarContainer,
	NavLogo,
	MobileIcon,
	NavMenu,
	NavLinks,
	NavItem,
	NavInfoLogo,
	NavImg
} from './NavbarStyles.js';
import { useLocation, useHistory } from 'react-router-dom';
import { data } from '../../data/NavbarData';
import { logoData } from '../../data/NavbarData';


const Navbar = () => {
	const [show, setShow] = useState(false);

	let history = useHistory();
	let location = useLocation();

	const handleClick = () => {
		setShow(!show);
	};

	const scrollTo = (id) => {
		const element = document.getElementById(id);

		element.scrollIntoView({
			behavior: 'smooth',
		});
	};

	const closeMobileMenu = (to, id) => {
		if (id && location.pathname === '/') {
			scrollTo(id);
		}

		history.push(to);
		setShow(false);
	};

	return (
		<IconContext.Provider value={{ color: '#fff' }}>
			<Nav>
				<NavbarContainer>
				<NavLogo  to="/">
						Odvjetnik Mioč
					</NavLogo>
				<NavMenu   show={show}>
						{data.map((el, index) => (
							<NavItem key={index}>
								<NavLinks onClick={() => closeMobileMenu(el.to, el.id)}>
									{el.text}
								</NavLinks>
							</NavItem>
						))}
					</NavMenu>
					
					<NavInfoLogo>
					<FaPhone /><a  href="tel:+385916609001" style={{color: "white"}}>+385919709210</a>
				<GiHouse /><a target="blank" href="https://www.google.hr/maps/place/Ilica+35,+10000,+Zagreb/@45.813274,15.9707062,3a,70.4y,211.41h,90.56t/data=!3m7!1e1!3m5!1sxxrQ4qwY_ddmvJs85m0IZA!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fpanoid%3DxxrQ4qwY_ddmvJs85m0IZA%26cb_client%3Dsearch.gws-prod.gps%26w%3D86%26h%3D86%26yaw%3D185.13977%26pitch%3D0%26thumbfov%3D100!7i16384!8i8192!4m5!3m4!1s0x4765d6e3278d29e1:0x46ae6df2e0188545!8m2!3d45.8129411!4d15.9706633" style={{color: "white", whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"}}>Ilica 35, 10000</a>	
					</NavInfoLogo>
					<MobileIcon onClick={handleClick}>
						{show ? <FaTimes style={{ color: "#060707" }}  /> : <CgMenuRight />}
					</MobileIcon>
					
				</NavbarContainer>
			</Nav>
		</IconContext.Provider>
	);
};

export default Navbar;
